<script>
  import BusinessCategoryItem from './BusinessCategoryItem';
  import ImageUpload from '@/components/ImageUpload';
  import { esellerMethods, esellerComputed, layoutMethods, exportMethods,erpFixMessages, erpUserRolesMethods  } from "@/state/helpers";

  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Business category component
   */
  export default {
    page: {
      title: "Business Category"
    },
    data() {
      return {
        logoPreview: null,
        title: "Business Category",
        folder: 'seller-categories',
        businessLogo: {
          filename: null,
          type: null,
          base64: null
        },
        pagination: {
          rows: 12,
          page: 1,
          search: null,
          searchField: 'name',
          sort: 'name',
          orderDesc: true
        },
        pageOptions: [12, 24, 36, 48, 60, 72, 84, 96, 108, 120],
        searchOptions: [
          {text: 'Business Category', value:'name'}
        ],
        sortOptions: [
          { text: 'Business Category', value: 'name' }
        ],
        sortOrderOptions: [
          {text: 'ASC', value:false},
          {text: 'DESC', value:true}
        ],
        editModal: false,
        createModal: false,
        businessCategoryItem: {
          businessCategoryId: null,
          businessCategoryName: '',
          businessCategoryImageSrc: ''
        },
        formExitChecker: {
          businessCategoryId: null,
          businessCategoryName: '',
          businessCategoryImageSrc: ''
        },
        file: null,
        paginationChecker: {
          search: null,
          orderDesc: true
        },
        isDisabled: 1,
        esuppliesCagegoriesModule: {
          access: {
            create: true,
            update: true
          }
        }
      };
    },
    components: { 
      BusinessCategoryItem,
      ImageUpload 
    },
    computed: {
      ...esellerComputed,
      ...erpFixMessages
    },
    methods: {
      ...layoutMethods,
      ...esellerMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      async onExport(){
        await this.search();
        if(this.categoryTotalRows ==0 ){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          this.pagination, 
          this.lookupParams, 
          {
            module: 'esupplies_categories',
            email: JSON.parse(localStorage.getItem('userData')).email
          }),
          page = params.page,
          rows = params.rows;
        
        delete params.page;
        delete params.rows;
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        params.page = page
        params.rows = rows
      },
      refresh(){
        this.listESellerCategories();
      },
      openCreateModal(){
        this.logoPreview = null;
        this.clearCategory();
        this.clearLogo();
        this.createModal = true;
      },
      async listESellerCategories(){
        await this.listSellerCategories(this.pagination);
      },
      createESellerCategory(){
        var categoryObj = { ...this.businessCategoryItem };
        delete categoryObj.productId;
              
        if(this.businessLogo.base64){
          var businessLogo = { ...this.businessLogo };
          businessLogo.folder = this.folder;

          this.uploadLogo(businessLogo)
            .then((imageKey) => {
              categoryObj = { 
                ...categoryObj,
                businessCategoryImageSrc: imageKey
              }
              
              this.create(categoryObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.create(categoryObj);
        }
      },
      editESellerCategory(businessCategory){
        if (!this.esuppliesCagegoriesModule.access.read && !this.esuppliesCagegoriesModule.access.update){
          Swal.fire(
            "Access Restricted", 
            "Looks like your access is limited. Please contact your administrator.", 
            "warning");
        } else {
          this.logoPreview = null;
          this.editModal = true;
          this.businessCategoryItem = {
            businessCategoryId: businessCategory.businessCategoryId,
            businessCategoryName: businessCategory.businessCategoryName,
            businessCategoryImageSrc: businessCategory.businessCategoryImageSrc
          };
          this.formExitChecker = {
            businessCategoryId: businessCategory.businessCategoryId,
            businessCategoryName: businessCategory.businessCategoryName,
            businessCategoryImageSrc: businessCategory.businessCategoryImageSrc
          };
        }
      },
      saveESellerCategory(){
        var categoryObj = { ...this.businessCategoryItem };
        delete categoryObj.businessCategoryImageSrc;

        if(this.businessLogo.base64){
          var businessLogo = { ...this.businessLogo };
          businessLogo.folder = this.folder;

          this.uploadLogo(businessLogo)
            .then((imageKey) => {
              categoryObj = { 
                ...categoryObj,
                businessCategoryImageSrc: imageKey
              }
              this.update(categoryObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.update(categoryObj);
        }
      },
      deleteESellerCategory(businessCategory){
        if(businessCategory.itemCount > 0){
          Swal.fire("Deletion Not Allowed!",`${businessCategory.businessCategoryName} is currently being used by some products. Deletion is not allowed.`, "error");
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: `Do you really want to delete ${businessCategory.businessCategoryName}? This process cannot be undone.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes",
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) {
              this.deleteSellerCategory(businessCategory.businessCategoryId)
                .then(() => {
                  Swal.fire("Delete Successful!", `${businessCategory.businessCategoryName} has been deleted.`, "success");
                  this.listESellerCategories();
                })
                .catch((e) => {
                  Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                });
            } else {
              return;
            }
          });
        }
      },
      create(categoryObj){
        this.createSellerCategory(categoryObj)
          .then(() => {
            this.createModal = false;
            Swal.fire("Create Successful!", `${categoryObj.businessCategoryName} has been created.`, "success");
            this.listESellerCategories();
            this.clearLogo();
          })
          .catch(() => {
            this.createModal = false;
            Swal.fire("Create Failed!",`${categoryObj.businessCategoryName} was not created.`, "error");
            this.clearLogo();
          });
      },
      update(categoryObj){
        this.updateSellerCategory(categoryObj)
          .then(() => {
            this.editModal = false;
            Swal.fire("Update Successful!", `${categoryObj.businessCategoryName} has been updated.`, "success");
            this.listESellerCategories();
            this.clearLogo();
          })
          .catch(() => {
            this.editModal = false;
            Swal.fire("Update Failed!",`${categoryObj.businessCategoryName} was not updated.`, "error");
            this.clearLogo();
          });
      },
      clearLogo(){
        this.businessLogo = {
          filename: null,
          type: null,
          base64: null
        }
      },
      clearCategory(){
        this.businessCategoryItem = {
          businessCategoryId: null,
          businessCategoryName: '',
          businessCategoryImageSrc: ''
        }
        this.formExitChecker = {
          businessCategoryId: null,
          businessCategoryName: '',
          businessCategoryImageSrc: ''
        }
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      async search(){
        if(
          (this.paginationChecker.search != this.pagination.search && this.paginationChecker.orderDesc != this.pagination.orderDesc) ||
          (this.paginationChecker.search != this.pagination.search)
        ){
          this.pagination.page = 1;
          this.paginationChecker.search = this.pagination.search;
          this.paginationChecker.orderDesc = this.pagination.orderDesc;
        }
        await this.listESellerCategories();
      },
      leaveform(modal = 'add'){
          if(JSON.stringify(this.businessCategoryItem) == JSON.stringify(this.formExitChecker)){
              if(modal == 'add'){
                  this.createModal = false;
              }else if(modal == 'edit'){
                  this.editModal = false;
              }
              this.clearCategory();
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  if(modal == 'add'){
                      this.createModal = false;
                  }else if(modal == 'edit'){
                      this.editModal = false;
                  }
                  this.clearCategory();
              }else{
                  return;
              }
          })
      },
      onDisplayChange(){
        console.log(this.categoryTotalRows,this.pagination.rows,this.categories.length,(this.categories.length < this.categoryTotalRows && this.categories.length != this.pagination.rows));
        if(
          (this.categories.length < this.categoryTotalRows && this.categories.length != this.pagination.rows) || // condition for incrementing display per page
          (this.categories.length == this.categoryTotalRows && this.pagination.rows < this.categories.length) // condition for decreasing display per page
          ){
          this.search()
        }
      }
    },
    async mounted(){
      this.listESellerCategories();
      this.changeTitle({title: 'E-Seller Business Category'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'E-Seller', to: { name: 'ESeller'} },
          { text: 'Business Categories', to: { name: 'ESeller Category'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eSupplies', 'Categories')
      .then((access) => this.esuppliesCagegoriesModule.access = access);

    }
  }
    
</script>

<template>
  <div>
        <div class="row">
            <div class="col-lg-12">
              <div class="card">
                  <div class="card-body">
                      <div class="row mb-3">
                          <div class="col-md-4 col-sm-4">
                              <div class="my-2">
                                  <h5 class="card-title text-dark">
                                      <span class="fw-normal ms-lg-2"
                                      >{{categoryTotalRows}}</span
                                      > Record(s)
                                  </h5>
                              </div>
                          </div>
                          <!-- end col --> 
                          
                          <div class="col-md-8 col-sm-8"> 
                              <div class="d-flex justify-content-lg-end mb-lg-3">
                                  <template>
                                    <div class="me-2">
                                      <b-button v-if="esuppliesCagegoriesModule.access.create" 
                                        @click="$router.push({ path: 'category/add' })" 
                                        variant="primary">
                                          <i class="uil uil-plus me-1"></i> 
                                            Add Business Category
                                      </b-button>
                                    </div>
                                  </template>

                                  <a class="btn btn-secondary"
                                    @click="refresh"
                                      ><feather
                                      type="refresh-ccw"
                                      size="16"
                                      class="icon nav-icon"
                                      ></feather
                                      >&nbsp;&nbsp; Refresh</a
                                  >
                              </div>
                          </div>
                          <div class="col-md-12 ta-right">
                              <div class="d-flex flex-wrap mt-3 mb-3">
                                  <div class="me-3">
                                    <b-form-group
                                      description="Search keyword"
                                    >
                                      <div class="d-flex">
                                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                                        v-model="pagination.searchField"
                                        :options="searchOptions"
                                      ></b-form-select>
                                      <b-form-input v-on:keyup.enter="search" v-model="pagination.search" class="rounded-0"></b-form-input>
                                      </div>
                                    </b-form-group>
                                  </div>
                                  <div class="me-3 w-350px">
                                    <b-form-group
                                      description="Order by"
                                    >
                                      <div class="d-flex">
                                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                                          v-model="pagination.sort"
                                          :options="sortOptions"
                                        ></b-form-select>
                                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                                          v-model="pagination.orderDesc"
                                          :options="sortOrderOptions"
                                        ></b-form-select>
                                      </div>
                                    </b-form-group>
                                  </div>
                                  <div class="me-2">
                                    <b-form-group
                                      label=""
                                    >
                                      <b-button variant="primary" type="button" @click="search" class="px-2">
                                        <i class='bx bx-search bx-fw'></i> Search
                                      </b-button>
                                    </b-form-group>
                                  </div>
                                  <div>
                                    <b-form-group label="">
                                      <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                                        <i class='uil uil-export me-1'></i> Export
                                      </b-button>
                                    </b-form-group>
                                  </div>
                              </div>
                          </div>
                          <!-- end col -->
                      </div>
                      <!-- end row -->

                      <!-- grid list business category -->
                      <!-- ISSUE NUMBER P2022-778 DISABLED EDIT AND DELETE -->
                      <template>
                        <div class="row">
                          <business-category-item
                            v-for="(businessCategory, index) in categories" 
                            @edit="$router.push({ path: `category/edit/${businessCategory.businessCategoryId}` })"
                            v-bind:key="index"
                            v-bind:businessCategory="businessCategory"
                            />
                        </div>
                      </template>
                      <!-- <template>
                        <div class="row">
                          <business-category-item
                            v-for="(businessCategory, index) in categories" 
                            v-bind:key="index"
                            v-bind:businessCategory="businessCategory"
                            @edit="editESellerCategory(businessCategory)"
                            @delete="deleteESellerCategory(businessCategory)"
                            />
                        </div>
                      </template> -->
                      <!-- end grid list business category -->

                      <div class="row g-0 text-center" v-if="categoryTotalRows == 0">
                        <span>No data to display.</span>
                      </div>

                      <div class="row g-0 text-center text-sm-start mt-3">
                        <!-- end col -->
                        <div class="col-sm-12" v-if="categoryTotalRows != 0 && categoryTotalRows > 12">
                          <div class="row">
                            <div class="col">
                              <div class="form-group row pull-left">
                                <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                                <div class="col-sm-6">
                                  <b-form-group label-for="display-record">
                                    <b-form-select class="form-select shadow-none w-fit"
                                      id="display-record"
                                      v-model="pagination.rows"
                                      :options="pageOptions"
                                      @change="onDisplayChange()"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>
                              </div>
                              <div class="dataTables_paginate paging_simple_numbers float-end" v-if="categoryTotalRows != 0 && categoryTotalRows > 12 && categoryTotalRows > pagination.rows">
                                <!-- pagination -->
                                <b-pagination
                                  class="pagination-rounded"
                                  v-model="pagination.page"
                                  @input="listESellerCategories"
                                  :total-rows="categoryTotalRows"
                                  :per-page="pagination.rows"
                                ></b-pagination>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end col -->
                      </div>

                  </div>
                  <!-- end card body -->
              </div>
              <!-- end card -->
            </div>
            <!-- end col -->
        </div>

        <!-- all modal -->
        <!-- create modal -->
        <b-modal
          id="modalAddBusinessCategory"
          title="Add Business Category"
          size="md"
          centered
          hide-footer
          hide-header-close
          v-model="createModal"
        >
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form class="px-4 py-3" @submit.prevent="handleSubmit(createESellerCategory)" @@reset.prevent="reset">
              <div class="row">
                <label v-if="!esuppliesCagegoriesModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a category.</label>
                <div class="col-md-12 mb-3">
                  <label class="form-label small fw-bold">Business Category<span style="color: red">*</span></label>
                  <validation-provider name="Category name" rules="required" v-slot="validationContext">
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Business Category"
                      :state="getValidationState(validationContext)"
                      v-model="businessCategoryItem.businessCategoryName"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
                <div class="col-md-12 mb-3">
                  <image-upload v-model="businessLogo" label="Category Logo" :isRequired="true" />
                </div>
              </div>

              <div class="text-end mt-3">
                <b-button
                  variant="light"
                  class="w-sm"
                  type="button"
                  @click="leaveform()"
                  >Close</b-button
                >
                <b-button :disabled="!esuppliesCagegoriesModule.access.create"
                  variant="primary" 
                  class="w-sm ms-2"
                  type="submit"
                  >Save</b-button
                >
              </div>
            </b-form>
          </ValidationObserver>
        </b-modal>
        <!-- end create modal -->
        <!-- edit modal -->
        <b-modal
          id="modalEditBusinessCategory"
          title="Edit Business Category"
          size="md"
          centered
          hide-footer
          hide-header-close
          v-model="editModal"
          >
            <ValidationObserver v-slot="{ handleSubmit, reset }">
              <b-form class="px-4 py-3" @submit.prevent="handleSubmit(saveESellerCategory)" @@reset.prevent="reset">
                <div class="row">
                    <label v-if="!esuppliesCagegoriesModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a category.</label>    
                    <div class="col-md-12 mb-3">
                      <label class="form-label small fw-bold">Business Category<span style="color: red">*</span></label>
                      <validation-provider name="Category name" rules="required" v-slot="validationContext">
                        <b-form-input
                          type="text"
                          class="form-control"
                          placeholder="Enter Business Category"
                          :state="getValidationState(validationContext)"
                          v-model="businessCategoryItem.businessCategoryName"
                          :disabled="isDisabled === 1"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                    <div class="cold-md-12 mb-3">
                      <image-upload v-model="businessLogo" label="Category Logo" :isRequired="false" :imageSrc="businessCategoryItem.businessCategoryImageSrc" />
                    </div>
                </div>

                <div class="text-end mt-3">
                    <b-button
                      variant="light"
                      class="w-sm"
                      type="button"
                      @click="leaveform('edit')"
                      >Close</b-button
                    >
                    <b-button :disabled="!esuppliesCagegoriesModule.access.update"
                      variant="primary" 
                      class="w-sm ms-2"
                      type="submit"
                      >Save</b-button
                    >
                </div>
            </b-form>
          </ValidationObserver>
        </b-modal>
        <!-- end edit modal -->
  </div>
</template>